<template>
    <div class="col col-12 ma-0 pa-0">
        <span class="ml-3">Состав заказа:</span>
        <v-btn @click="cardSelectBoxShow = true" icon fab small>
            <v-icon small>add</v-icon>
        </v-btn>
        <v-col v-for="(card, index) in cardsInCard"
               :key="card.id"
                class="py-1"
        >
            <v-card class="pa-1 mb-1">
                <v-card-actions class="py-0">
                    <v-container fluid class="py-0">
                        <v-row>
                            <v-col cols="6" class="pa-0" align-self="end">
                                <span class="title body-2">{{card.title}}</span>
                            </v-col>
                            <v-col cols="1" class="pa-0" align-self="end">
                                <v-btn small icon color="primary" @click="downCount(index)"><v-icon small>remove</v-icon></v-btn>
                            </v-col>
                            <v-col cols="2" class="pa-0 mx-1">
                                <v-text-field
                                        v-model="arrayCards[index][1]"
                                        hide-details
                                        dense
                                        type="number"
                                        :input="checkButtonShow = true"
                                />
                            </v-col>
                            <v-col cols="1" class="pa-0" align-self="end">
                                <v-btn small icon color="primary" @click="upCount(index)"><v-icon small>add</v-icon></v-btn>
                            </v-col>
                            <v-col cols="1" class="pa-0" align-self="end" v-show="checkButtonShow" @click="changeCountCards(index)">
                                <v-btn small icon color="success"><v-icon small>check</v-icon></v-btn>
                            </v-col>

                            <v-col cols="8" class="pa-0 pa-0">
                                <span class="caption">Стоимость {{card.price}} рублей</span>
                            </v-col>
                            <v-col cols="8" class="pa-0 pa-0">
                                <span class="caption">Итого: {{card.price * arrayCards[index][1]}} руб.</span>
                            </v-col>
                            <v-spacer/>
                            <v-col cols="1" class="pa-0 pa-0" align-self="end">
                                <v-btn
                                        small
                                        icon
                                        color="red lighten-2"
                                        @click="cardDelete(index)"
                                >
                                    <v-icon small>delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-col>
        <card-select-box
                :dialog="cardSelectBoxShow"
                @close="cardSelectBoxShow = false"
                @addCards="addCards"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CardSelectBox from './CardSelectBox'

export default {
    name: 'CardsInCard',
    props: ['cardId'],
    components: {
        CardSelectBox
    },
    data() {
        return {
            cardsInCard: [],
            cardIds: [],
            cardSelectBoxShow: false,
            arrayCards: [],
            checkButtonShow: false
        }
    },
    computed: {
        ...mapGetters({
            cards: 'cards/cards',
            getCardById: 'cards/getCardById'
        }),
        card() {
            return this.getCardById(this.cardId)
        }
    },
    watch: {
        cardId() { this.loadCards() },
        cardsInCard() { this.solveSum() }
    },
    created() {
        this.loadCards()
    },
    methods: {
        addCards(cards) {
            this.$emit('addCards', cards)
            cards.forEach(item => {
                let index = this.cardsInCard.findIndex(card => card.id === item[0])
                let card = this.getCardById(item[0])
                if (index === -1) {
                    this.cardsInCard.push(card)
                    this.arrayCards.push(item)
                } else {
                    this.arrayCards[index][1] += item[1]
                }
            })
        },
        loadCards() {
            if (this.cardId != null && this.card.cards != null && this.card.cards.length > 0) {
                this.$store.dispatch('cards/cardsInCardAll', this.cardId).then(response => {
                    if (response.ok) {
                        this.cardsInCard = response.response.data
                    }
                })
                this.arrayCards = []
                let arrayCards = this._.cloneDeep(this.card.cards)
                arrayCards.forEach((item, i) => {
                    this.$set(this.arrayCards, i, item)
                })
                this.solveSum()
            } else {
                this.arrayCards = []
                this.cardsInCard = []
            }
        },
        upCount(index) {
            this.$set(this.arrayCards[index], 1, +this.arrayCards[index][1] + 1)
            this.changeCountCards(index)
        },
        downCount(index) {
            if (this.arrayCards[index][1] - 1 < 0) {
                this.arrayCards[index][1] = 1
            }
            this.$set(this.arrayCards[index], 1, this.arrayCards[index][1] - 1)
            this.changeCountCards(index)
        },
        changeCountCards(index) {
            this.solveSum()
            this.$emit('changeCountCards', { index: index, count: +this.arrayCards[index][1] })
        },
        cardDelete(index) {
            this.$emit('removeCard', index)
            this.cardsInCard.splice(index, 1)
            this.arrayCards.splice(index, 1)
        },
        solveSum() {
            let sum = 0
            this.cardsInCard.forEach((item, index) => {
                sum += this.arrayCards[index][1] * item.price
            })
            this.$emit('sumChange', sum)
        }
    }
}
</script>

<style scoped>

</style>
